if (!customElements.get('industries-with-projects')) {
  customElements.define(
    'industries-with-projects',
    class IndustriesWithProjects extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isActive: 'is-active',
          projectWrap: '#selected-industry__projects',
        };

        this.hoverTracker = null;
        this.hoverHandler = this.handleHover.bind(this);
      }

      get allItems() {
        return (this._allItems =
          this._allItems || JSON.parse(this.querySelector('[type="application/json"]').textContent));
      }

      get projectsGridEl() {
        return (this._projectsGridEl = this._projectsGridEl || this.querySelector('#selected-industry__projects'));
      }

      connectedCallback() {
        this.industries = this.querySelectorAll('.card-industry');
        if (this.industries) {
          this.industries.forEach((cardEl) => {
            cardEl.addEventListener('mouseenter', this.hoverHandler);
          });
          this.setActiveItem(this.industries[0]);
        }
        this.projectsGridEl.addEventListener('mouseenter', (e) => this.handleProjectsHovered(e));
      }

      handleHover(event) {
        if (AfcTheme.config.mqlMobile) {
          return;
        }

        clearTimeout(this.hoverTracker);
        this.hoverTracker = setTimeout(() => {
          const { target } = event;
          if (target.classList.contains(this.classes.isActive)) return;

          this.setActiveItem(target);
        }, 250);
      }

      handleProjectsHovered() {
        clearTimeout(this.hoverTracker);
      }

      setActiveItem(target) {
        this.industries.forEach((cardEl) => {
          cardEl.classList.remove(this.classes.isActive);
        });

        this.selectedIndustry = {
          id: target.dataset.industryHandle,
          url: target.dataset.industryUrl,
          label: target.dataset.industryLabel,
        };

        target.classList.add(this.classes.isActive);
        const selectedValueEl = this.querySelector('.selected-industry__value');
        selectedValueEl && (selectedValueEl.textContent = this.selectedIndustry.label);

        this.showProjects();
      }

      showProjects() {
        this.prepareData();
        this.renderProjects();
      }

      prepareData() {
        this.activeFilters = {};

        this.items = this.filterProjects(this.allItems, {
          industry: this.selectedIndustry.id,
        });
        this.items = this.sortByOrder(this.items);
        this.totalItems = this.items.length;
      }

      renderProjects() {
        this.projectsGridEl.innerHTML = '';
        let output = '';

        for (let index = 0; index < this.totalItems; index++) {
          const project = this.items[index];
          output += this.getProjectHtml(project, index);

          if (index === 4) {
            break;
          }
        }

        this.projectsGridEl.innerHTML = output;
      }

      getProjectHtml(project, index) {
        let itemUrl = project.url;
        let itemClass = 'featured-project-card relative w-full hover-wrapper media-wrapper';
        let imageSizes = '200px';
        let overlay = '';
        if (index == 0) {
          itemClass += ' is-highlight blocks-radius';
          imageSizes = '810px';
        } else {
          itemClass += ' blocks-radius-md';
        }

        if (index === 0) {
          overlay = `
          <div class="content-overlay content-overlay--bottom-left">
            <div class="bg-overlay"></div>
            <div class="relative z-1 rich-text">
              <h3 class="h4 featured-project-card__name">${project.name}</h3>
            </div>
          </div>`;
        } else if (index === 4 && this.totalItems > 5) {
          overlay = `
          <div class="content-overlay content-overlay--middle-center">
            <div class="bg-overlay" style="--color-overlay-alpha: 60;"></div>
            <div class="relative z-1 rich-text">
              <div class="link-lg">View more</div>
            </div>
          </div>`;
          itemUrl = this.selectedIndustry.url;
        }

        const thumbnail = project.media
          ? this.getShopifyImage(project.media, {
              widths: [188, 376, 550, 810, 1100, 1620],
              sizes: imageSizes,
              widthAttr: 810,
              heightAttr: 608,
              classes: 'w-full motion-reduce hover-scale-up',
            })
          : this.getPlaceholderImage();

        return `
        <a class="${itemClass}" href="${itemUrl}">
          <motion-element class="block" data-motion="zoom-out-sm">${thumbnail}</motion-element>
          ${overlay}
        </a>
        `;
      }

      filterProjects(projects, filters) {
        return projects.filter((project) => {
          return Object.entries(filters).every(([key, value]) => {
            if (value === '') return true; // Skip filtering for empty string.
            return project[key]?.id === value;
          });
        });
      }

      sortByOrder(data) {
        return data.sort((a, b) => {
          const sortA = a.sort_order;
          const sortB = b.sort_order;

          if (sortA === '' && sortB !== '') {
            return 1;
          }
          if (sortA !== '' && sortB === '') {
            return -1;
          }
          if (sortA === '' && sortB === '') {
            return 0;
          }
          // If both are not empty, sort numerically.
          return parseInt(sortA) - parseInt(sortB);
        });
      }

      getShopifyImageUrl(url, options = {}) {
        try {
          if (typeof url !== 'string' || url === '') {
            console.log('Invalid image url', url);
          }

          const { width, height } = options;

          if (!width && !height) {
            // Do nothing if no width or height is specified.
            return url;
          }

          let modifiedUrl = url;

          // Add query parameters based on the options provided.
          const separator = url.includes('?') ? '&' : '?';
          const params = new URLSearchParams();

          if (width) params.append('width', Math.floor(width));
          if (height) params.append('height', Math.floor(height));

          // Append parameters to the URL if any were added.
          if (Array.from(params).length > 0) {
            modifiedUrl += `${separator}${params.toString()}`;
          }

          return modifiedUrl;
        } catch (e) {
          console.log(e);

          return false;
        }
      }

      getShopifyImage(url, options = {}) {
        const {
          width,
          height,
          loading = '',
          classes = '',
          widths = [],
          sizes = '',
          alt = '',
          style = '',
          widthAttr,
          heightAttr,
          isImageLazy = true,
        } = options;

        const imageUrl = this.getShopifyImageUrl(url, options);
        if (!imageUrl) {
          return '';
        }

        // Generate srcset by mapping each width in the array to a URL
        const srcset = Array.isArray(widths)
          ? widths.map((w) => `${this.getShopifyImageUrl(url, { width: w })} ${w}w`).join(', ')
          : '';

        return `
        <img src="${imageUrl}" 
          ${isImageLazy ? `is="image-lazy"` : ''}
          ${widthAttr ? `width="${widthAttr}"` : ''} 
          ${heightAttr ? `height="${heightAttr}"` : ''}
          ${loading ? `loading="${loading}"` : ''}
          ${classes ? `class="${classes}"` : ''}
          ${srcset ? `srcset="${srcset}"` : ''}
          ${sizes ? `sizes="${sizes}"` : ''}
          ${style ? `style="${style}"` : ''}
          ${alt ? `alt="${alt}"` : ''}>`;
      }

      getPlaceholderImage() {
        return '<svg class="placeholder-svg w-full h-full hover-scale-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>';
      }
    }
  );
}
